import React from "react";

export default ({id, onChange, disabled, multiple}) => (
  <input
    type="file"
    className="merchant-upload__input"

    id={id}
    onChange={onChange}
    disabled={disabled}

    multiple={multiple}
  />
)
